import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { EndSessionRequest } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private readonly msal: MsalService) {}
 

  getUserNid(): string | undefined {
    const account = this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0];

    const claims = account?.idTokenClaims as Record<string, unknown> | undefined;
    const nid = claims?.['nid'] ?? claims?.['uid'];
    return typeof nid === 'string' ? nid.toUpperCase() : undefined;
  }

  async getToken(): Promise<string | null> {
    const account = this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0];

    if (!account) {
      return null;
    }

    try {
      console.time('AcquireToken');
      const result = await this.msal.instance.acquireTokenSilent({
        account,
        scopes: environment.loadCargoApi.scopes,
      });
      console.timeEnd('AcquireToken');
      const token = result.accessToken;
      return token;
    } catch (error) {
      console.error('Failed to acquire token silently:', error);
      return null;
    }
  }
  private decodeJwt(token: string): any {
    try {
      const payload = token.split('.')[1];
      return JSON.parse(
        atob(
          payload
            .replaceAll('-', '+')
            .replaceAll('_', '/')
        )
      );
    } catch (error) {
      console.error('Failed to decode JWT:', error);
      return null;
    }
  }
  
  async getRoles(): Promise<string[]> {
    const token = await this.getToken();
  
    if (!token) {
      return [];
    }
  
    const claims = this.decodeJwt(token);
  
    return Array.isArray(claims?.['roles'])
      ? (claims['roles'] as string[])
      : [];
  }
 

  signOut(relativeRedirect: string = '/'): void {
    const instance = this.msal.instance;
    const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? undefined;
    instance.setActiveAccount(null);
    localStorage.clear();
    sessionStorage.clear();
    
    const origin = globalThis.location?.origin ?? '';

    const postLogoutRedirectUri = relativeRedirect.startsWith('http')
      ? relativeRedirect
      : origin + relativeRedirect;

    const request: EndSessionRequest = {
      account,
      postLogoutRedirectUri,
    };

    this.msal.logoutRedirect(request);
  }
}
